import { Link, useNavigate } from "react-router-dom";
import "../../assets/css/Slider.css";
import "../../assets/css/admin.css";
import logoutIcon from "../../assets/img/logout.svg";
import { IMAGES } from "../../assets/img/ImageIndex";

export default function Slider() {
  const navigate = useNavigate();

  const handleLogOut = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  return (
    <div className="admin-sidebar">
      <div className="admin-sidebar-header">
        <div className="admin-sidebar-logo">
          <Link to="/" className="flex items-center">
            <img src={IMAGES.logo} alt="Ridge Crest" />
          </Link>
        </div>
        <hr className="admin-sidebar-divider" />
        <nav className="admin-sidebar-nav">
          <div>
            <Link
              to="/admin/dashboard"
              className="admin-sidebar-link"
            >
              <h2>Dashboard</h2>
            </Link>
            <Link
              to="/admin/blogs"
              className="admin-sidebar-link"
            >
              <h2>Blog</h2>
            </Link>
          </div>
        </nav>
      </div>

      <div
        className="admin-sidebar-footer"
        onClick={handleLogOut}
      >
        <div className="admin-logout-content">
          <span className="admin-logout-text">Logout</span>
          <img src={logoutIcon} alt="Logout" className="admin-logout-icon" />
        </div>
      </div>
    </div>
  );
}
